import { useEffect, useRef } from 'react';

import { InvoiceClientUtils } from '@ravago/shared/next-data-access/client';
import { InvoiceQueryParams } from '@ravago/shared/page-data/models/elements';

import { useInvoiceDispatchContext, useInvoiceStateContext } from '../context/invoice-context';
import { InvoiceAction } from '../state/invoice.actions';

export const useFetchClosedInvoices = (hasClosedInvoicesPermission: boolean, isOpen: boolean, query: InvoiceQueryParams) => {
   const { closedInvoices } = useInvoiceStateContext();
   const dispatch = useInvoiceDispatchContext();

   const prevInvoiceNumberRef = useRef(query.identifier);

   useEffect(() => {
      const invoiceNumberChanged = prevInvoiceNumberRef.current !== query.identifier;
      const shouldFetch = hasClosedInvoicesPermission && !isOpen && (!closedInvoices?.[query.page] || invoiceNumberChanged);

      if (!shouldFetch) {
         return;
      }

      const fetchClosedInvoices = async () => {
         try {
            const updatedQuery = { ...query, page: query.page - 1 };
            const invoicesResponse = await InvoiceClientUtils.getClosedInvoices(updatedQuery);

            if (invoicesResponse && !invoicesResponse.empty) {
               invoicesResponse.number += 1;
               dispatch({ type: InvoiceAction.SET_CLOSED_INVOICES, payload: invoicesResponse });
            } else {
               dispatch({ type: InvoiceAction.CLOSED_INVOICES_NOT_FOUND });
            }
         } catch (_) {
            dispatch({ type: InvoiceAction.CLOSED_INVOICES_NOT_FOUND });
         }
      };

      fetchClosedInvoices();

      prevInvoiceNumberRef.current = query.identifier;
   }, [isOpen, query.page, query.identifier, dispatch, closedInvoices]);
};
